/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import {Dispatch} from 'redux'
import { handleEnterprisePlanDialog } from '../../../../../../setup/redux/auth/actions'
import { useDispatch } from 'react-redux'
import { Modal } from 'react-bootstrap'
import { Step1 } from '../Step1'
import { useFormikContext } from 'formik'
import { createICCompany } from '../../../../../../setup/redux/auth/actions'
import * as Yup from 'yup'

const EnterPriseStepModal: FC<{
  isEnterprisePlanDialog: boolean
  validationSchema: Yup.ObjectSchema<any>
}> = ({ isEnterprisePlanDialog, validationSchema }) => {

  const dispatch: Dispatch<any> = useDispatch()
  const formik = useFormikContext();

  const handleClose = () => {
    formik.setValues({
      ...(formik.values as { [key: string]: any }),
      team_size_id: undefined,
    });
    dispatch(handleEnterprisePlanDialog(false));
  }

  const handleSubmit = (values: any) => {
    validationSchema
      .validate(values, { abortEarly: false })
      .then(() => {
        const obj = {
          user_id: values.user_id,
          name: values.companyName,
          email: values.email,
          phone: values.phone,
          location: values.address,
          state: values.state,
          city: values.city,
          country: values.country,
          zip_code: values.zipcode,
          country_code: values.country_code,
          is_active: true,
          subscription_plan: values.subscription_plan,
          sectors: values.sectors,
          team_size_id: values.team_size_id,
          company_registration_number: values.companyRegistrationNumber,
          vat_number: values.vatNumber,
        }
        dispatch(createICCompany(obj))
      })
      .catch((validationErrors: any) => {
        const errors: { [key: string]: string } = {}
        validationErrors.inner.forEach((error: { path: string; message: string }) => {
          errors[error.path] = error.message
        })
        formik.setErrors(errors)
      })
  }

  return (
    <>
      {isEnterprisePlanDialog && (
        <Modal
          show={isEnterprisePlanDialog}
          onHide={handleClose}
          tabIndex={0}
          className='modal-lg modal-dialog-scrollable'
        >
          <Modal.Header closeButton>
            <Modal.Title className='fs-1'>Enterprise Plan</Modal.Title>
          </Modal.Header>
          <Modal.Body className='enterPriseModal enterprise-container'>
            <Step1 formik={formik} isModel={true} />
          </Modal.Body>
          <Modal.Footer>
            <button
              type='button'
              className='btn btn-light'
              data-bs-dismiss='modal'
              onClick={handleClose}
            >
              Close
            </button>
            <button
              type='submit'
              className='btn btn-primary isOpacityDisable'
              onClick={() => handleSubmit(formik.values)}
              onKeyDown={() => handleSubmit(formik.values)}
            >
              Submit
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  )
}

export { EnterPriseStepModal }
